import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, adicionaIconesGrid, calculaAlturaGrid } from './../app.config';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-religiao',
  templateUrl: './religiao.component.html',
  styleUrls: ['./religiao.component.css']
})
export class ReligiaoComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  editOptionsGridReligiao = {
    mode: GridConfig.gridMode, // form
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Religião',
      showTitle: true
    }
  };

  colunasGridReligiao = null;
  religiao = null;
  alturaGrid = null;

  constructor(@Inject(Http) http: Http) {

    this.religiao = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/religiao/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/religiao/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/religiao/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/religiao/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });

    this.colunasGridReligiao = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'DescricaoReligiao',
        dataType: 'string',
        caption: 'Descrição da Religião',
        validationRules: [{
          type: 'required',
          message: 'Descrição da Religião é obrigatório.'
        }]
      }
    ];
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }
}



// WEBPACK FOOTER //
// ./src/app/religiao/religiao.component.ts